"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.useAuthentication = exports.default = exports.authContextShape = exports.AuthProvider = exports.AuthContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _invariant = _interopRequireDefault(require("invariant"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _router = require("../router");
var _AuthClient = _interopRequireDefault(require("./AuthClient"));
var _redux = require("../redux");
var _AuthNobiaClient = _interopRequireDefault(require("./AuthNobiaClient"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var AuthContext = exports.AuthContext = /*#__PURE__*/(0, _react.createContext)({
  client: null
});
var useAuthentication = exports.useAuthentication = function useAuthentication() {
  return (0, _react.useContext)(AuthContext);
};
var AuthProvider = exports.AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children,
    store = _ref.store,
    options = _ref.options,
    _ref$nobiaClient = _ref.nobiaClient,
    nobiaClient = _ref$nobiaClient === void 0 ? false : _ref$nobiaClient,
    _ref$preserveState = _ref.preserveState,
    preserveState = _ref$preserveState === void 0 ? true : _ref$preserveState;
  var reduxStore = (0, _redux.useStore)();
  var _useState = (0, _react.useState)(),
    client = _useState[0],
    setClient = _useState[1];
  (0, _react.useEffect)(function () {
    var _store = store || reduxStore;
    (0, _invariant.default)(_store, "Store is missing in context and wasn't passed as a prop to AuthProvider.");
    var _client = nobiaClient ? new _AuthNobiaClient.default(options, {
      store: _store,
      preserveState: preserveState
    }) : new _AuthClient.default(options, {
      store: _store,
      preserveState: preserveState
    });
    setClient(_client);
    _client.subscribe();
    if (preserveState && !_client.isAuthenticated()) {
      _client.restoreLocalSession();
    }
    return function () {
      return _client.unsubscribe();
    };
  }, []);
  var memoedState = (0, _react.useMemo)(function () {
    return {
      client: client
    };
  });
  return /*#__PURE__*/_react.default.createElement(AuthContext.Provider, {
    value: memoedState
  }, children);
};
var authContextShape = exports.authContextShape = _propTypes.default.object;
var _default = exports.default = (0, _router.withRouter)(AuthProvider);